// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  hmr: false,
  APIBaseUrl: "http://stagecreditaugmentor.com/api/",
  ArrayAppKey: '54E60B98-2EB9-433F-8E0F-FA72BDA88C60',
  ArrayServerToken: "85B3BE2A-D138-4A6C-9013-F62A7BC94D3E",
  ArrayApiURL: 'https://sandbox.array.io/api/',
  SetMore: {
    ApiURL: 'https://developer.setmore.com/api/v1/',
    HomeroadMap:{
      RefreshToken: 'r1/73b8b9040cQUzHNMQlVTiWCt-EMQ-Jb0yZrBpe1tfzipL',
      StaffKey: '2ec230ce-8779-4365-b1ed-a79c06de7c9e',
      WelcomeCallServiceKey: 'fda25629-f7a6-45d8-829f-bac0e2dd6077',
      StrategyCallServiceKey: '0e0dbe1f-3942-4523-b554-1a3b70ef33c0',
    },
    CreditRepairmen:{
      RefreshToken: 'r1/8323bddadca49TJ3uILCnKDbvNS0aSQ8ixdzTF32BQ4zS',
      StaffKey: 'rcb30b317003aca69176abd6246ff3f31f78e7f12',
      WelcomeCallServiceKey: 'a8a0f4f7-c11e-4cc9-9f70-89b799f5e2f9',
      StrategyCallServiceKey: 's19a81574177756090',
    }
  }
  // APIBaseUrl: "https://service.creditaugmentor.com/api/",
  // ArrayAppKey: '54E60B98-2EB9-433F-8E0F-FA72BDA88C60',
  // ArrayServerToken: "85B3BE2A-D138-4A6C-9013-F62A7BC94D3E",
  // ArrayApiURL: 'https://array.io/api/',
  // SetMore: {
  //   ApiURL: 'https://developer.setmore.com/api/v1/',
  //   HomeroadMap:{
  //     RefreshToken: 'r1/73b8b9040cQUzHNMQlVTiWCt-EMQ-Jb0yZrBpe1tfzipL',
  //     StaffKey: '2ec230ce-8779-4365-b1ed-a79c06de7c9e',
  //     WelcomeCallServiceKey: 'fda25629-f7a6-45d8-829f-bac0e2dd6077',
  //     StrategyCallServiceKey: '0e0dbe1f-3942-4523-b554-1a3b70ef33c0',
  //   },
  //   CreditRepairmen:{
  //     RefreshToken: 'r1/8323bddadca49TJ3uILCnKDbvNS0aSQ8ixdzTF32BQ4zS',
  //     StaffKey: 'rcb30b317003aca69176abd6246ff3f31f78e7f12',
  //     WelcomeCallServiceKey: 'a8a0f4f7-c11e-4cc9-9f70-89b799f5e2f9',
  //     StrategyCallServiceKey: 's19a81574177756090',
  //   }
  // }
};



// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/environments/environment.ts